import React,{useState,useEffect} from 'react';
import { useSelector } from 'react-redux';

///Styles
import { FiMoreVertical } from 'react-icons/fi'
import {ContainerLoading,Container,Content,Groups,TableProducts,Button} from './styles'

///Components
import { SpaceLoader } from '../../../../loaders/spaceLoader';
import { ExportFiles } from '../ExportFiles'


///Services
import { api } from '../../../../../services/api';
import { formatMoney } from '../../../../../Utils/formatMoney';
import moment from 'moment';
import { download_csv } from '../JsonToCsv';
import { toast } from 'react-toastify';


export function CanceledOrders(){

    const rankingDatas = useSelector(state => state.modalCentralized.datasComponent);

    const [ordersCanceled,setOrdersCanceled] = useState([]);
    const [page,setPage] = useState(1)
    const [loading,setLoading] = useState(true);
    const [loadingButton,setLoadingButton] = useState(false);
    const [isOpenExcelButton, setIsOpenExcelButton] = useState(false);

    async function handleFetchNewDates(){
        setLoadingButton(true);
        await api.post(`/getCanceledOrders?page=${page}`,
        {
            business:  rankingDatas.business,
            salesChannels: rankingDatas.salesChannels,
            endDate: rankingDatas.endDate,
            startDate: rankingDatas.startDate
        },
        {
            headers: {
                'Content-Type': 'application/json',
                 token: localStorage.getItem('@Inoveclube:token')
            }
        })
        .then((response) => {
            if(response.data.sucess === 0){
                toast.error(response.data.error);
                return
            }
            //console.log(response.data)
            const data = handleData(response.data.datas)
            setOrdersCanceled([...ordersCanceled,...data]);
            setPage(response.data.next_page)
        })
        .catch((error) => {
            toast.error('Ops, algo deu errado');
        })
        setLoadingButton(false);
    }

    useEffect(() => {
        async function loadOrdersCanceled(){
           await api.post('/getCanceledOrders?page=1',
            {
                business:  rankingDatas.business,
                salesChannels: rankingDatas.salesChannels,
                endDate: rankingDatas.endDate,
                startDate: rankingDatas.startDate
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                     token: localStorage.getItem('@Inoveclube:token')
                }
            })
            .then((response) => {
                if(response.data.sucess === 0){
                    toast.error(response.data.error);
                    setLoading(false);
                    return
                }
                setOrdersCanceled(handleData(response.data.datas));
                setPage(response.data.next_page);
                setLoading(false);
            })
            .catch((error) => {
                toast.error('Ops, algo deu errado');
                setLoading(false);
            })
        }
        loadOrdersCanceled();
    },[rankingDatas.business, rankingDatas.endDate, rankingDatas.startDate, rankingDatas.salesChannels]);

    const handleData = (data) => {
        const result = Object.entries(data.reduce((acc, {RowNum, cancellationDate,dateOrder,idBusiness,idCustomized,nameBusiness,nameEmployee,namePerson,note,numberOrder,salesChannel,value, cnpj}) => {
            acc[nameBusiness] = (acc[nameBusiness] || []);
            acc[nameBusiness].push({
                RowNum, 
                cancellationDate,
                dateOrder,
                idBusiness,
                idCustomized,
                nameEmployee,
                namePerson,
                note,
                numberOrder,
                salesChannel,
                value
            });
            return acc;
        },{}))
        .map(([key, value]) => ({name: key, children: value}));
        return result
    }

        ///Baixando o relatório em Excel
        async function handleDownloadCSV(){
            setLoading(true);
    
            const response = await api.post('/getCanceledOrders?page=0',
            {
                business:  rankingDatas.business,
                salesChannels: rankingDatas.salesChannels,
                endDate: rankingDatas.endDate,
                startDate: rankingDatas.startDate
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                     token: localStorage.getItem('@Inoveclube:token')
                }
            })
    
            const cancelOrdes = response.data.datas.map((item) => {
                return {
                    Codigo: item.idBusiness,
                    Id_Customizado: item.idCustomized,
                    CNPJ: item.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
                    Empresa: item.nameBusiness,
                    Cliente: item.namePerson,
                    Numero_Venda: item.numberOrder,
                    Funcionário_Cancelamento: item.nameEmployee,
                    Canal_Venda: item.salesChannel,
                    Data_Cancelamento: moment(item.cancellationDate).utcOffset(0).format('DD/MM/YYYY HH:mm:ss'),
                    Valor: Number(item.value).toFixed(2).replace('.',','),
                    Motivo: item.note,
                }
            });
        
            download_csv(cancelOrdes, 'Vendas Canceladas')
            setLoading(false);
        }  

    if(loading){
        return(
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }


    return(
        <Container>
            <div className="seeMore">
                <FiMoreVertical
                    onClick={() => setIsOpenExcelButton(!isOpenExcelButton)}
                />

                <ExportFiles 
                    handleDownloadCSV={handleDownloadCSV}
                    isOpen={isOpenExcelButton}
                    setIsOpen={setIsOpenExcelButton}
                />
            </div>

            <Content>
                {
                    ordersCanceled.map((business) => {
                        return(
                            <Groups key={business.name}>
                                <h3>&#8226;{business.name}</h3>

                                <TableProducts>
                                    <thead>
                                        <tr>
                                            <th>Cliente</th>
                                            <th>Funcionário</th>
                                            <th>Data</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            business.children.map((item) => {
                                                return(
                                                    <tr key={item.numberOrder}>
                                                        <td>
                                                            {item.namePerson}
                                                            {item.note.length !== 0 &&
                                                                <p>Motivo: {item.note}</p>
                                                            }
                                                        </td>
                                                        <td>{item.nameEmployee.split(' ').slice(0,1)}</td>
                                                        <td>{moment(item.cancellationDate).format('DD/MM/YY HH:mm')}</td>
                                                        <td>{(formatMoney(item.value))}</td>
                                                    </tr>
                                                )
                                            })
                                        }

                                        <tr>
                                            <td>Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                            {
                                                formatMoney(
                                                    business.children.map((item) => {
                                                        return item.value
                                                    })
                                                    .reduce((value,next) => {
                                                        return value + next
                                                    })
                                                )
                                            }
                                            </td>
                                        </tr>
                                    </tbody>
                                </TableProducts>
                            </Groups>
                        )
                    })
                }
            </Content>

            {
                page !== null &&
                <Button onClick={handleFetchNewDates}>
                    {
                        loadingButton ? 
                        '...aguarde'
                        :
                        'Ver Mais'
                    }
                </Button>
            }
        </Container>
    )
}